import { DoubleSide, Mesh, MeshLambertMaterial, type BufferGeometry, type WebGLProgramParametersWithUniforms } from "three"
import type { Engine } from "../../../../core/engine/Engine.type"
import { mountOnFrameUpdateToObject3D } from "../../../../event/GameObject3D/GameObject3DFrameUpdate/GameObject3DFrameUpdate"
import { grassVertexShader } from "./grassShaders"

const grassMaterial = new MeshLambertMaterial({
  vertexColors: true,
  side: DoubleSide,
})

const iTime = {
  value: performance.now(),
}

grassMaterial.onBeforeCompile = (shader: WebGLProgramParametersWithUniforms) => {
  shader.uniforms.iTime = iTime
  shader.vertexShader = grassVertexShader
  grassMaterial.userData.shader = shader
}

export default function createGrassWavesObject(
  engine: Engine,
  geometry: BufferGeometry,
) {
  const mesh = new Mesh(geometry, grassMaterial)

  mountOnFrameUpdateToObject3D(engine, mesh, (dt: number, at: number) => {
    iTime.value = at
  })

  return mesh
}
